<template>
  <div
    class="flex items-start justify-between w-full max-lg:flex-col-reverse max-lg:gap-8"
  >
    <div class="w-full h-full flex items-center justify-center lg:max-w-[35%] mt-6">
      <NuxtImg
        src="/images/what-we-can-do.webp"
        height="463"
        width="428"
        loading="lazy"
        :preload="false"
        :alt="data?.sub_text"
        format="webp"
      />
    </div>

    <div class="flex flex-col lg:items-start w-full lg:max-w-[50%]">
      <h3 class="xl:text-[44px] text-[31px] mt-5 font-bold relative max-lg:text-center w-full">
        <WrGradientText append-class="pb-0 leading-[1.3]">
          {{ data?.main_heading }}
        </WrGradientText>
      </h3>

      <p class="text-lg mt-5 max-lg:text-center w-full font-semibold">
        {{ data?.sub_text }}
      </p>

      <ul
        class="grid grid-cols-2  max-sm:[95%] max-lg:w-[80%] max-lg:place-items-start gap-6 mt-6 max-lg:mx-auto"
      >
        <li
          v-for="item in data?.features"
          :key="item.heading"
          class="flex items-start gap-2 lg:w-[80%] text-base self-start"
        >
          <NuxtImg
            src="/images/right-single.webp"
            alt="feature icon"
            width="16"
            height="16"
            class="mt-[6px] flex-shrink-0"
            loading="lazy"
            :preload="false"
            format="webp"
          />
          <span>{{ item.heading }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  data: Object;
}>();
</script>
